export default __webpack_public_path__ + "914c39a.png";